import styled from '@emotion/styled'
import { keyframes, css } from '@emotion/core'
import Title from 'components/Utilities/Title'
import Text from 'components/Utilities/Text'
import Button from 'components/Utilities/Button'

const revealLineY = () => css`
  ${keyframes`
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  `} 1s ease-in-out forwards;
`

const revealLineY2 = () => css`
  ${keyframes`
    0% {
      transform: scaleY(1);
    }
    100% {
      transform: scaleY(0);
    }
  `} 1s ease-in-out forwards;
`

const revealLineX = () => css`
  ${keyframes`
    0% {
      transform: scaleX(0);
    }
    100% {
      transform: scaleX(1);
    }
  `} 1s ease-in-out forwards;
`

const revealLineX2 = () => css`
  ${keyframes`
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  `} 1s ease-in-out forwards;
`

export const FormHeaderContainerStyled = styled.div``

export const StyledTitle = styled(Title)`
  font-weight: 200;
  margin-bottom: 30px;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.xl_small};
  }
`

export const StyledBody = styled(Text)`
  font-weight: 200;
  max-width: 1000px;
  margin-bottom: 40px;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.xxs};
  }
`

export const FormContainerStyled = styled.div`
  background-color: ${props => props.theme.colors.lightblue};
  min-height: 1100px;
  padding: 80px 20px;
  width: 100%;
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding-right: 50px;
    padding-left: 50px;
    padding-top: 150px;
    margin-top: -200px;
  }

  @media (min-width: ${props => props.theme.breakpoints.l}) {
    padding-right: 100px;
    padding-left: 100px;
  }

  @media (min-width: 1270px) {
    padding-right: 186px;
    padding-left: 186px;
  }
`

export const AnimatedBorderContainer = styled.div`
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 40px 0px;
  }

  &:before {
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      content: '';
      background-color: ${props => props.theme.colors.primarygreen};
      position: absolute;
      height: calc(100% - 175px);
      top: 0;
      right: -200px;
      width: 1px;
      z-index: 100000;
      transform-origin: top;
      transform: scaleY(0);
      animation: ${props => (props.isVisible ? revealLineY : revealLineY2)};
      animation-delay: 2s;

      @media (min-width: 800px) {
        right: -100px;
      }

      @media (min-width: ${props => props.theme.breakpoints.l}) {
        right: -200px;
      }
    }
  }

  &:after {
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      background-color: ${props => props.theme.colors.primarygreen};
      width: calc(100% + 200px);
      top: 0px;
      left: 0;
      content: '';
      position: absolute;
      height: 1px;
      transform-origin: left;
      transform: scaleX(0);
      animation: ${props => (props.isVisible ? revealLineX : revealLineX2)};
      animation-delay: 1s;

      @media (min-width: 800px) {
        width: calc(100% + 100px);
      }

      @media (min-width: ${props => props.theme.breakpoints.l}) {
        width: calc(100% + 200px);
      }
    }
  }
`

export const FormStyled = styled.form`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;

  > *:not(:last-of-type) {
    @media (max-width: 500px) {
      border-bottom: 0;
    }
  }
`

export const FormContent = styled.div`
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: calc(100% - 100px);
  }

  @media (min-width: ${props => props.theme.breakpoints.l}) {
    width: calc(100% - 200px);
  }
`

export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.primarygreen};
  padding: 12px 12px 0;

  @media (min-width: 500px) {
    width: 50%;
    padding: 15px 28px 0;
  }

  :first-of-type {
    @media (min-width: 500px) {
      border-right: 0;
    }
  }

  :last-of-type {
    @media (min-width: 500px) {
      border-top: 0;
    }
  }
`

export const FormLabel = styled.label`
  font-size: ${props => props.theme.fonts.xxxs_medium};
  font-weight: 300;
`

export const FormInput = styled.input`
  font-weight: 500;
  background: transparent;
  padding-bottom: 15px;
  font-size: ${props => props.theme.fonts.xxs};

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.m};
  }

  @media (min-width: 500px) {
    padding-bottom: 28px;
  }

  :focus {
    outline: none;
  }
`

export const SelectGroup = styled.div`
  display: flex;
  background: ${props => props.theme.colors.white};
  width: 100%;
  flex-direction: column;
  border: 1px solid ${props => props.theme.colors.primarygreen};
  position: relative;
  padding: 12px 12px 15px;

  @media (min-width: 500px) {
    width: 50%;
    padding: 15px 28px 0;
    border-top: 0;
    border-right: 0;
  }

  ::before {
    content: '';
    border-style: solid;
    border-width: 8px 8px 0 8px;
    width: 10px;
    height: 10px;
    border-color: ${props => props.theme.colors.primarygreen} transparent
      transparent transparent;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    transform: ${props =>
      props.showList ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)'};

    @media (min-width: 500px) {
      top: 53px;
      transform: ${props =>
        props.showList ? 'rotate(180deg) translateY(3px)' : 'initial'};
    }
  }
`

export const SelectOptions = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  opacity: ${props => (props.showList ? 1 : 0)};
  pointer-events: ${props => (props.showList ? 'auto' : 'none')};
  z-index: ${props => (props.showList ? '1' : '0')};
  position: absolute;
  top: 97px;
  border: 1px solid ${props => props.theme.colors.primarygreen};
  border-top: 0;
  left: -1px;
  width: calc(100% + 2px);
  background: ${props => props.theme.colors.white};

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    top: 102px;
  }

  @media (max-width: 500px) {
    top: 81px;
  }
`

export const SelectOption = styled.li`
  font-size: ${props => props.theme.fonts.xxs};
  padding: 18px 28px;
  cursor: pointer;

  @media (max-width: 500px) {
    padding: 12px;
  }

  :hover {
    background: ${props => props.theme.colors.lightblue};
  }
`

export const SelectedOption = styled.select`
  background: transparent;
  appearance: none;
  font-weight: 500;
  cursor: pointer;
  font-size: ${props => props.theme.fonts.xxs};

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.m};
  }

  :focus {
    outline: none;
  }

  option {
    display: none;
  }
`

export const FormTextarea = styled.textarea`
  margin-top: 15px;
  font-weight: 500;
  border: 1px solid ${props => props.theme.colors.primarygreen};
  width: 100%;
  padding: 12px 12px 15px;
  min-height: 243px;
  font-size: ${props => props.theme.fonts.xxs};

  @media (min-width: 500px) {
    padding: 15px 28px;
    margin-top: 30px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.m};
    min-height: 264px;
  }

  :focus {
    outline: none;
  }
`

export const SubmitButton = styled(Button)`
  width: 193px !important;
  margin-left: auto !important;
  margin-top: 33px !important;

  @media (min-width: 500px) {
    margin-top: 30px !important;
  }

  .MuiButton-label {
    text-transform: capitalize;
    letter-spacing: normal;
  }
`
